import React from 'react';
import './App.css';
import Background from './components/Background';
import ProfileHeader from './components/ProfileHeader';
import CardsGrid from './components/CardsGrid';

function App() {
  return (
    <div className="App dark-bg">
      <Background />
      <main className="main-container">
        <section className="hero-section">
          <ProfileHeader />
        </section>
        <CardsGrid />
      </main>
    </div>
  );
}

export default App;



